export default __webpack_public_path__ + "static/1_highflyer-aerial-2-7e546acd0eb1ca691f0187256803622f.png";